import { useEffect, useRef } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { getMarketBySlug } from '../utils/api';
import { mapApiItems } from '../utils/marketUtils';

/**
 * 处理单个市场详情模式
 */
export function useSingleMarket({ onDataLoad, pushToast }) {
  const params = useParams();
  const location = useLocation();
  const isLoadingRef = useRef(false);
  const singleMarketMode = location.pathname.startsWith('/market/');

  useEffect(() => {
    if (!singleMarketMode) return;

    const slug = params.slug;
    if (!slug) {
      onDataLoad({
        marketData: [],
        activeMarketIndex: 0,
        hasNext: false
      });
      return;
    }

    let cancelled = false;

    (async () => {
      try {
        isLoadingRef.current = true;

        const res = await getMarketBySlug(slug);

        if (!res || (res.code !== 0 && res.code !== 1) || !res.data) {
          pushToast && pushToast('加载市场详情失败', 'info');
          isLoadingRef.current = false;
          return;
        }

        const item = res.data;
        const mapped = mapApiItems([item]);

        if (cancelled) return;

        onDataLoad({
          marketData: mapped,
          activeMarketIndex: 0,
          page: 1,
          hasNext: false
        });

        setTimeout(() => {
          isLoadingRef.current = false;
        }, 100);
      } catch (e) {
        console.error('加载市场详情失败:', e);
        isLoadingRef.current = false;
        pushToast && pushToast('加载失败，请稍后重试', 'info');
      }
    })();

    return () => {
      cancelled = true;
      isLoadingRef.current = false;
    };
  }, [singleMarketMode, params.slug, onDataLoad, pushToast]);

  return { singleMarketMode, isLoadingRef };
}
